'use strict';

var implementation = require('./implementation');

module.exports = Function.prototype.bind || implementation;



//////////////////
// WEBPACK FOOTER
// ./~/_function-bind@1.1.1@function-bind/index.js
// module id = 197
// module chunks = 0